export class User {
    id: number;
    userName: string;
    password: string;
    firstName: string;
    lastName: string;
    token?: string;
    accessLevel: number;
    accessPermissions: string[];
}
